module.exports = __webpack_public_path__ + "media/images/sample/eyecatch-posts-3d7b217a1483662f37fc6eee79be49ce.png";